



































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IInputTab } from './common-models';

@Component({})
export default class OtTabs extends Vue {
  // * PROPS
  @Prop() private tabsData?: IInputTab[];
  // this should only be used with tabs without routes
  // tabs with routes should use the route matching logic that's baked into the tab component
  // this is for times where you're not going to navigate on clicking the tab, you just want to show the contents
  // So, practically, it'll only ever be a number. The vuetify doco has it as any, I'm not doing that.
  // The vuetify doco also says it'll be the href or the tab index, so I'm doing the typing off that
  @Prop() private activeTab?: string | number;

  private isTabActive(tab: IInputTab, index: number) {
    if (!tab.tabRoute) {
      return index === this.activeTab;
    }
    if (tab.tabRoute.path) {
      return this.$route.path === tab.tabRoute.path;
    }

    if (this.$route.name && tab.tabRoute.name) {
      const result = this.$route.name.localeCompare(tab.tabRoute.name, undefined, { sensitivity: 'base' });
      return result === 0 ? true : false;
    }

    return false;
  }
  // * REFS

  // * DATA

  // * COMPUTED
  private get hasFooter() {
    return Boolean(this.$slots.footer);
  }

  private get activeTabValue() {
    return this.activeTab;
  }
  private set activeTabValue(value: string | number | undefined) {
    this.$emit('update:activeTab', value);
  }

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
